/**
 * Analytics store
 *
 * Manages analytics data, metrics, and dashboard statistics.
 *
 * Reference: Zustand store pattern
 * https://github.com/pmndrs/zustand
 */
import { create } from 'zustand';
const defaultAnalytics = {
    meetings: {
        totalMeetings: 0,
        totalDuration: 0,
        averageDuration: 0,
        byStatus: {
            draft: 0,
            recording: 0,
            processing: 0,
            completed: 0,
            archived: 0,
        },
        overTime: [],
    },
    usage: {
        totalRecordings: 0,
        totalTranscriptions: 0,
        totalStorageMB: 0,
        apiCalls: 0,
        overTime: [],
    },
    lastUpdated: null,
};
export const useAnalyticsStore = create((set, get) => ({
    // State
    dashboardAnalytics: null,
    period: 'month',
    dateRange: {
        start: null,
        end: null,
    },
    isLoading: false,
    isRefreshing: false,
    error: null,
    // Actions
    setDashboardAnalytics: (analytics) => {
        set({ dashboardAnalytics: analytics });
    },
    setPeriod: (period) => {
        set({ period });
    },
    setDateRange: (start, end) => {
        set({
            dateRange: {
                start,
                end,
            },
        });
    },
    setLoading: (isLoading) => {
        set({ isLoading });
    },
    setRefreshing: (isRefreshing) => {
        set({ isRefreshing });
    },
    setError: (error) => {
        set({ error });
    },
    clearError: () => {
        set({ error: null });
    },
    reset: () => {
        set({
            dashboardAnalytics: null,
            period: 'month',
            dateRange: {
                start: null,
                end: null,
            },
            isLoading: false,
            isRefreshing: false,
            error: null,
        });
    },
}));
//# sourceMappingURL=analytics.js.map